import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const AuthGuard = ({ moduleName }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = () => {
      try {
        const authFlag = localStorage.getItem("fleet_authenticated");
        const userStr = localStorage.getItem('fleet_user');

        if (authFlag !== "true" || !userStr) {
          navigate('/login', { replace: true });
          return;
        }

        const user = JSON.parse(userStr);
        const email = user.email || user.preferred_username;

        if (!email) {
          setIsAuthorized(false);
          setLoading(false);
          return;
        }

        // TODO: Add AD group-based auth based on moduleName
        setIsAuthorized(true);
      } catch (err) {
        console.error("AuthGuard Error:", err);
        setIsAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [navigate, moduleName]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg-primary)' }}>
        <p style={{ color: 'var(--text-secondary)' }}>Verifying {moduleName || ''} access...</p>
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg-primary)' }}>
        <div style={{
          background: 'var(--bg-secondary)',
          padding: '40px',
          borderRadius: '16px',
          border: '1px solid rgba(255,255,255,0.05)',
          textAlign: 'center'
        }}>
          <h2 style={{ color: 'var(--text-primary)' }}>Access Denied</h2>
          <p style={{ color: 'var(--text-muted)' }}>You don't have permission to view this module.</p>
          <button onClick={() => navigate('/', { replace: true })} style={{ padding: '8px 16px', cursor: 'pointer' }}>
            Return to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};
